import Integration from "../integration/Integrations";
import { Tag } from "./Tag";
var simplePageViewEventTag = new Tag(function () {
    Integration.submitAnalyticEvent({
        eventName: "pageView",
        page: document.location.pathname
    }).catch(function (reason) { return console.warn("Analytic event submission failed with reason [".concat(reason, "]")); });
});
export default simplePageViewEventTag;
